<template>
  <div class="wg-chart">
    <div v-if="problem" class="wg-problem">{{ problem }}</div>
    <Chart_V5
      v-else
      :key="renderKey"
      :chart_data="chart.chart_data"
      :chart_config="chart.chart_config"
      :override-height="height ? height + 'px' : undefined"
      :show-export="false"
    />
  </div>
</template>

<script>
import Chart_V5 from '@/components/widgetcomponents/Viz_Elements/Chart_V5.vue';
import { buildVizProps } from '@/utils/metricInsightAdapter';

export default {
  name: 'ChartWidget',
  components: { Chart_V5 },
  props: {
    inputs: { type: Object, default: () => ({}) },
    config: { type: Object, default: () => ({}) },
    width: { type: Number, default: 0 },
    height: { type: Number, default: 0 },
  },
  computed: {
    rows() {
      return (this.inputs.rows || {}).rows || [];
    },
    columns() {
      return (this.inputs.rows || {}).columns || [];
    },
    labelField() {
      return this.config.label_field || this.columns.find((c) => /NAME|LABEL|DT|DATE|MONTH|YEAR/i.test(c)) || this.columns[0];
    },
    series() {
      if (Array.isArray(this.config.series) && this.config.series.length) return this.config.series;
      const value = this.columns.find((c) => /^VALUE$/i.test(c)) || this.columns.find((c) => c !== this.labelField);
      return value ? [{ value_field: value, label: value, type: this.config.type || 'bar' }] : [];
    },
    problem() {
      if (!this.rows.length) return 'No rows.';
      if (!this.labelField || !this.series.length) return 'Choose a label column and at least one value column.';
      return '';
    },
    chart() {
      const built = buildVizProps('chart_v5', {
        label_field: this.labelField,
        series: this.series,
        chart_config: {
          chartType: this.config.chart_type || 'vertical_bar',
          legend: { display: this.series.length > 1, position: 'top', spacing: 15 },
          formatting: { percentage: !!this.config.percentage, sig_figs: this.config.sig_figs ?? 1 },
          ...(this.config.chart_config || {}),
        },
      }, this.rows);
      return built.props;
    },
    renderKey() {
      return `${this.width}x${this.height}:${this.rows.length}`;
    },
  },
};
</script>

<style scoped>
.wg-chart { width: 100%; height: 100%; min-height: 0; }
.wg-problem { padding: 16px; font-size: 12.5px; color: #8b877f; }
</style>
